module.exports = __webpack_public_path__ + "resources/img/img_LOH_pc_kr.63a1a1b81bcfd984a5b35835bf92fb0d.png";